import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spAddress";

const SpAddressMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    // --- Payload update logic (from old mapper) ---
    const rawFormValues = {
      title: "Address Change",
      "New House Name or Number": data.lookUpAddress?.house,
      "New Postcode": data.postcode,
      "Reason for changing address": data.reasonAddress?.label,
      "Will the vehicle be parked on your drive overnight?": data.overNightHome,
      ...(data.overNightHome === "No" && {
        "Where is your vehicle located overnight?": data.locOverNight?.label,
        "What is the overnight postcode?": data.overNightPostcode,
      }),
      "Will your vehicle continue to be licenced by the existing licensing authority?":
        data.exitingLicenseAuth,
      ...(data.exitingLicenseAuth === "No" && {
        "What will be the licensing authority?": data.LicenseAuth?.label,
      }),
    };
    const formValues = Object.fromEntries(
      Object.entries(rawFormValues).filter(
        ([, value]) => value !== undefined && value !== null && value !== ""
      )
    );
    const formattedData = formatData(formValues);

    store.updateField("Address_Changes_Details__c", formattedData);
    store.updateField("Address_Changes__c", true);
    store.updateField(
      "Address_Changes_Effective_From__c",
      formatDateT(data.addressEffectiveDateTime) || ""
    );
  },
};

export default SpAddressMapper;
